import React from "react";
import PaymentStatus from "../components/payment/PaymentStatus";

const PaymentCallback = () => {
  return <PaymentStatus />;
};

export default PaymentCallback;
